import { render } from "./DriverAbout.vue?vue&type=template&id=0acefd22&scoped=true"
import script from "./DriverAbout.vue?vue&type=script&lang=js"
export * from "./DriverAbout.vue?vue&type=script&lang=js"

import "./DriverAbout.vue?vue&type=style&index=0&id=0acefd22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0acefd22"]])

export default __exports__